import { getCountryData } from 'countries-list';

export type AdminPermission =
  | 'item.create'
  | 'item.update'
  | 'item.delete'
  | 'location.update'
  | 'user.create'
  | 'user.update'
  | 'user.delete';

export type Permission =
  | 'order.create'
  | 'order.update'
  | 'order.create-on-behalf'
  | 'order.import-inventory'
  | AdminPermission;

export type AdminRole =
  | 'CHECKA Location Admin'
  | 'CHECKA User Admin'
  | 'CHECKA Order Admin'
  | 'CHECKA Stock Admin';

export type Role = 'CHECKA Location Viewer' | AdminRole;

export type UserRole = {
  id: number;
  clientReference: string;
  name: Role;
  service: string;
  description: string;
  permissions: {
    name: Permission;
  }[];
};

export type User = {
  user: {
    username: string; // email
  };
  roles: {
    assignedManually: boolean;
    name: Role;
    clientHierarchyType: string;
    description: string;
  }[];
};

const SCOPES_WEIGHT = [
  {
    prefix: 'PLATFORM_OWNER',
    getChunk: (continent: string, country: string) => 'PLATFORM_OWNER',
  },
  {
    prefix: 'LIG.',
    getChunk: (continent: string, country: string) => 'LIG.\\d{3}',
  },
  {
    prefix: 'CON.',
    getChunk: (continent: string, country: string) => `CON.${continent}`,
  },
  {
    prefix: 'CTY.',
    getChunk: (continent: string, country: string) => `CTY.${country}`,
  },
];

const getRoleRegex = (scope: string, scopeCountry: string) => {
  const uCountry = scopeCountry.toUpperCase();
  const uScope = scope.toUpperCase();
  const { continent } = getCountryData(uCountry as any);
  const regexChunks = [uScope];

  for (const weight of SCOPES_WEIGHT) {
    if (uScope.startsWith(weight.prefix)) {
      break;
    }
    regexChunks.push(weight.getChunk(continent, uCountry));
  }

  return new RegExp(`(${regexChunks.join('|')})$`);
};

export const checkPermission = (
  roles: UserRole[],
  permissionToCheck: Permission,
  scope: string,
  scopeCountry: string
) => {
  const regex = getRoleRegex(scope, scopeCountry);

  return roles.some(
    ({ clientReference, permissions }) =>
      regex.exec(clientReference) &&
      permissions.some(({ name }) => name === permissionToCheck)
  );
};

export const checkRole = (
  roles: UserRole[],
  roleToCheck: Role,
  scope: string,
  scopeCountry: string
) => {
  const regex = getRoleRegex(scope, scopeCountry);

  return roles.some(
    ({ clientReference, name }) =>
      regex.exec(clientReference) && name === roleToCheck
  );
};
